import {
  SR_API_ACTION_RUN_CREDIT_AND_BACKGROUND_REPORT,
} from 'api/actionTypes';

export default async function runCreditAndBackgroundReport(
  { state, apiClient },
  { userId, listingId, householdApplicationId }
) {
  return apiClient.postWithState({
    action: SR_API_ACTION_RUN_CREDIT_AND_BACKGROUND_REPORT,
    state: state,
    payload: {
      userId,
      listingId,
      householdApplicationId,
    },
    onSuccess(tenantAlertReport) {
      state.set(['household', 'tenantAlertReportByUserId', userId], tenantAlertReport);
    },
  });
}
